import React from 'react';

export default function ChevronLeft() {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path stroke="#3899EC" strokeWidth="2" d="M15 6l-6 6 6 6" fill="none" />
    </svg>
  );
}

ChevronLeft.displayName = 'ChevronLeft';
